import { useNavigate } from 'react-router-dom';
import { Badge, SelectableCard } from '@tb/ui';
import { useCustomCode } from '../billing/useCustomCode';
import { useT } from '../i18n/LocaleProvider';

export interface CustomCodeCardProps {
  selected: boolean;
  disabled?: boolean;
  description: string;
  onSelect: () => void;
}

export function CustomCodeCard({ selected, disabled, description, onSelect }: CustomCodeCardProps) {
  const navigate = useNavigate();
  const access = useCustomCode();
  const t = useT();

  if (access.unlocked) {
    return (
      <SelectableCard
        icon="code"
        title={t('new.custom.title')}
        description={description}
        selected={selected}
        disabled={disabled}
        onClick={onSelect}
      />
    );
  }

  return (
    <SelectableCard
      icon="lock"
      title={t('new.custom.title')}
      description={
        access.priceGram
          ? t('new.custom.locked', { price: access.priceGram })
          : t('new.custom.lockedNoPrice')
      }
      onClick={() => void navigate('/plans')}
      trailing={
        access.priceGram ? (
          <Badge tone="accent" icon="gram">
            {access.priceGram}
          </Badge>
        ) : undefined
      }
    />
  );
}
